import { Loader } from "@/components/site/Loader";
import { Hero } from "@/components/site/Hero";
import { RiskTeaser } from "@/components/site/RiskTeaser";
import { Services } from "@/components/site/Services";
import { IntroVideo } from "@/components/site/IntroVideo";
import { WhoWeServe } from "@/components/site/WhoWeServe";
import { PartnerNetwork } from "@/components/site/PartnerNetwork";
import { FinalCTA } from "@/components/site/FinalCTA";

// Homepage = short cinematic introduction; full content lives on internal pages.
export default function Home({ showLoader = true }) {
  return (
    <>
      {showLoader && <Loader />}
      <Hero />
      <RiskTeaser />
      <Services preview />
      <IntroVideo />
      <WhoWeServe />
      <PartnerNetwork />
      <FinalCTA />
    </>
  );
}
